import { AnalysisModel } from "ts/filters/analysisModel";

export const isModelVirtual = (id: number, models: AnalysisModel[]) => {
  if (!id) return false;
  return models.find((m) => m.modelId === id)?.isVirtual;
};
